import React, { useState } from "react";

import { Button, Modal, message, Row, Col, Table, Divider } from "antd";
import { UploadOutlined, EyeOutlined } from "@ant-design/icons";
import { FileUploader } from "./FileUploader";
import { createTable, createWorkbook, TemplateFile } from "./Upload";

export const UploadTemplate = ({
  open = undefined,
  action = "upload",
  onClose = undefined,
  buttonTitle = null,
  fields,
  modalTitle,
  uploadRequest,
}) => {
  const [table, setTable] = useState(null);
  const [file, setFile] = useState(null);
  const [loadingVisualization, setLoadingVisualization] = useState(false);
  const [savingTable, setSavingTable] = useState(false);
  const [uploadingTable, setUploadingTable] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [showDescriptions, setShowDescriptions] = useState(true);

  const headers = fields.map((item) => item.name);

  const columns = headers.map((header) => ({
    key: header,
    title: header,
    dataIndex: header,
  }));

  const resetUploadModalState = () => {
    setFile(null);
    setTable(null);
    setSavingTable(false);
    setUploadingTable(false);
    setLoadingVisualization(false);
    setShowDescriptions(true);
  };

  const canSaveTable = () => {
    return file !== null && !savingTable;
  };

  const saveTable = () => {
    if (!canSaveTable()) {
      return;
    }
    setSavingTable(true);
    setLoadingVisualization(true);

    createWorkbook(file)
      .then((workbook) => createTable(workbook))
      .catch(() => {
        message.error("Falha ao criar pré-visualização!");
        setFile(null);
      })
      .then((tableResponse) => {
        setTable(tableResponse);
        setSavingTable(false);
        setLoadingVisualization(false);
        setShowDescriptions(false);
      });
  };

  const canUploadTable = () => {
    return table !== null && !uploadingTable && !savingTable;
  };

  const uploadTable = async () => {
    if (!canUploadTable()) {
      return;
    }
    setUploadingTable(true);
    try {
      await uploadRequest(table);
    } finally {
      resetUploadModalState();
      message.success(
        "Sua importação ocorrerá em segundo plano! Você receberá um e-mail de confirmação quando a operação for concluida.",
      );
    }
    if (onClose !== undefined) onClose();
    else setModalOpen(false);
  };

  const onCancel = () => {
    resetUploadModalState();
    if (onClose !== undefined) onClose();
    setModalOpen(false);
  };

  return (
    <>
      <Modal
        title={modalTitle}
        open={open !== undefined ? open : modalOpen}
        onCancel={() => onCancel()}
        width={"60vw"}
        centered
        style={{ marginTop: 0 }}
        footer={[
          <Button
            loading={loadingVisualization}
            icon={<EyeOutlined />}
            type="primary"
            key="preview"
            onClick={() => saveTable()}
            disabled={!canSaveTable()}
          >
            Pré visualizar
          </Button>,
          <Button
            disabled={!canUploadTable()}
            icon={<UploadOutlined />}
            type="primary"
            key="import"
            onClick={() => uploadTable()}
          >
            Importar
          </Button>,
        ]}
      >
        <Row style={{ fontSize: 16 }}>
          Importe as informações no sistema conforme os campos abaixo
        </Row>
        <Row>
          <Button
            onClick={() => setShowDescriptions(!showDescriptions)}
            type="link"
          >
            {showDescriptions ? "Esconder Descrições " : "Mostrar Descrições >"}
          </Button>
        </Row>

        {showDescriptions && (
          <Row style={{ fontSize: 13 }}>
            <ul>
              {fields.map((field) => (
                <li key={action + field.name}>
                  <strong>
                    {field.name} {field.required && "*"}{" "}
                  </strong>
                  : {field.description}
                  {field.options && Array.isArray(field.options) && (
                    <ul style={{ marginTop: 4 }}>
                      {field.options.map((opt) => (
                        <li key={opt.value}>
                          <strong>{opt.value}</strong>: {opt.label}
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </Row>
        )}

        <Divider />
        <Row align="middle">
          <Col span={4} offset={1}>
            <TemplateFile headers={headers} fileName={action} />
          </Col>
          <Col span={16} offset={1}>
            <FileUploader file={file} saveFile={setFile} />
          </Col>
        </Row>
        <Row>
          {table && (
            <Table
              columns={columns}
              dataSource={table}
              pagination={{
                position: ["topRight"],
                size: "small",
                showSizeChanger: true,
              }}
              bordered
              size="middle"
              scroll={{ x: "55vw" }}
            />
          )}
        </Row>
      </Modal>
      {open === undefined && onClose === undefined && (
        <Button type="default" onClick={() => setModalOpen(true)}>
          <UploadOutlined />
          {buttonTitle}
        </Button>
      )}
    </>
  );
};
